import Reveal from '@/components/base/Reveal';
import { Link } from 'react-router-dom';

export default function Cta() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
        <Reveal>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm border border-accent-200">
            诚邀共建 · 千县万村
          </div>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            让每一个县域拥有自己的数字商业基础设施
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            九畴云铺已找到具体应用场景、完成 0# 首发验证，期待与投资人、产业伙伴与县域从业者携手共建。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <Link
              to="/contact/business"
              className="px-8 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
            >
              联系我们
            </Link>
            <Link
              to="/about/resources"
              className="px-8 py-3 rounded-md border border-primary-400 text-primary-600 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-50"
            >
              查看相关资料
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}